import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'tallymark-2', 'IconTallymark2', [["path",{"d":"M10 5l0 14","key":"svg-0"}],["path",{"d":"M14 5l0 14","key":"svg-1"}]]);